// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LanguageSwitcherModal-cls1__b0a5084c1b1da184627c{/*!*/}.LanguageSwitcherModal-cls2___fb110d28c1e3ce37ac7{width:40px;height:26px;margin:15px 8px}@media only screen and (max-width: 560px){.LanguageSwitcherModal-cls2___fb110d28c1e3ce37ac7{width:8vw;height:5.2vh;margin:1em .5em}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "LanguageSwitcherModal-cls1__b0a5084c1b1da184627c",
	"cls2": "LanguageSwitcherModal-cls2___fb110d28c1e3ce37ac7 LanguageSwitcherModal-cls1__b0a5084c1b1da184627c"
};
export default ___CSS_LOADER_EXPORT___;
